import React, {useState, useEffect, useRef, useContext} from "react";
import {useParams, useLocation, useHistory} from "react-router-dom";
import {SelectStyled} from "../../styles/Forms";
import {Grid, Col} from "../../styles/Grid";
import FormPartOne from "./components/FormPartOne";
import styled from "styled-components";
import {CreateCourseService, SingleCourseService, UpdateCourseService} from "../../services/CoursesServices";
import AppLoader, {LoadComponet} from "../../components/loaders/Loader";
import EditCourseProvider, {EditCourseContext} from "../../context/EditCourseProvider";
import FormPartThree from "./components/FormPartThree";
import FormPartTwo from "./components/FormPartTwo";
import FormPartFour from "./components/FormPartFour";

function PrimeEditView({theme}) {
   let location = useLocation();
   let {id, type} = useParams();
   let history = useHistory();
   let secondF = useRef(null);
   let viewRef = useRef(null);
   const {defaultData, isSaving, isLoadingData} = useContext(EditCourseContext);
   const [addTo, setAdd] = useState(null);
   const [currentPage, setCurrentPage] = useState(1);
   const [currentTheme, setCurrentTheme] = useState({...theme, back: "#8e44ad"});
   const [isSavingData, setSavingData] = useState(false);

   useEffect(() => {
      if (location.state) {
         setCurrentTheme(location.state.page);
      }
   }, [location]);

   function update(e) {
      e.preventDefault();
      setSavingData(true);
      let form = e.target.elements;
      let dataSend = new FormData();
      dataSend.append("idCourse", id);
      dataSend.append("visible", true);
      dataSend.append("token", localStorage.getItem("domecq_token"));
      dataSend.append("shortDescription", form.shortDescription.value);
      dataSend.append("courseName", form.courseName.value);
      dataSend.append("courseCode", form.courseCode.value);
      dataSend.append("longDescription", form.longDescription.value.replace(/\n/g, "<br>"));
      dataSend.append("graduateProfile", form.graduateProfile.value);
      dataSend.append("startDate", form.startDate.value);
      dataSend.append("endDate", form.endDate.value);
      dataSend.append("linkEventBrite", form.linkEventBrite.value);
      if (form.pathImageDesktop.files[0]) {
         dataSend.append("pathImageDesktop", form.pathImageDesktop.files[0]);
      }
      if (form.pathImageMobile.files[0]) {
         dataSend.append("pathImageMobile", form.pathImageMobile.files[0]);
      }

      UpdateCourseService(dataSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            console.log(resp);
            if (status === "error") throw new Error("Erro");
            setSavingData(false);
         })
         .then(() => {
            if (Number(type) === 3) {
               history.goBack();
            } else {
               setCurrentPage(2);
            }
         })
         .catch((e) => {
            console.log(e);
            setSavingData(false);
            history.goBack();
         });
   }

   if (isLoadingData) return <LoadComponet isVisible={true} />;
   if (!defaultData) return null;
   return (
      <>
         <View ref={viewRef}>
            <Grid>
               <Col large={12}>
                  <Grid>
                     <TabSection
                        back={currentTheme.back}
                        className={currentPage === 1 ? "isActive" : ""}
                        onClick={() => {
                           setCurrentPage(1);
                        }}
                     >
                        <span>Datos generales</span>
                     </TabSection>
                     {Number(type) !== 3 && (
                        <>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 2 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(2);
                              }}
                           >
                              <span>Recursos y vídeos</span>
                           </TabSection>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 3 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(3);
                              }}
                           >
                              <span>Temario</span>
                           </TabSection>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 4 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(4);
                              }}
                           >
                              <span>Facilitadores</span>
                           </TabSection>
                        </>
                     )}
                  </Grid>
               </Col>
               <Col large={10} offsetL={1}>
                  <PartsContent>
                     <Parts className={currentPage === 1 ? "isActive" : ""}>
                        <FormPartOne save={update} data={defaultData} theme={theme} />
                     </Parts>
                     <Parts className={currentPage === 2 ? "isActive" : ""}>
                        <FormPartTwo
                           data={defaultData}
                           theme={theme}
                           continueAction={() => {
                              setCurrentPage(3);
                           }}
                           isVisible={currentPage === 2}
                        />
                     </Parts>
                     <Parts className={currentPage === 3 ? "isActive" : ""}>
                        <FormPartThree // temario
                           data={defaultData}
                           theme={theme}
                           continue={() => {
                              setCurrentPage(4);
                           }}
                        />
                     </Parts>
                     <Parts className={currentPage === 4 ? "isActive" : ""}>
                        <FormPartFour
                           data={defaultData}
                           theme={theme}
                           continueAction={() => {
                              history.goBack();
                           }}
                        />
                     </Parts>
                  </PartsContent>
               </Col>
            </Grid>
         </View>
         <AppLoader isVisible={isSaving} />
         <AppLoader isVisible={isSavingData} />
      </>
   );
}

const PrimeEdit = ({theme}) => {
   return (
      <EditCourseProvider>
         <PrimeEditView theme={theme} />
      </EditCourseProvider>
   );
};
export default PrimeEdit;

const View = styled.div`
   background: white;
   width: 100%;
`;

const PartsContent = styled.div`
   position: relative;
   width: 100%;
`;

const Parts = styled.div`
   width: 100%;
   height: 100%;
   z-index: 0;
   opacity: 0;
   height: 0;
   overflow: hidden;

   &.isActive {
      z-index: 10000000;
      opacity: 1;
      height: auto;
      overflow: initial;
   }
`;

const TabSection = styled.div`
   padding: 0.3em 0.7em;
   font-weight: 300;
   user-select: none;
   color: ${(props) => props.back || "#32529ds"};
   border: 1px inset ${(props) => props.back || "#32529ds"};
   margin-right: 0.5em;
   cursor: pointer;
   transition: all 900ms;

   &.isActive {
      background: ${(props) => props.back || "#32529d"};
      color: white;
      border-color: #32529ds;
      transition: all 420ms;
   }

   &:hover {
      background: ${(props) => props.back || "#32529ds"};
      color: white;
      border-color: grey;
      transition: all 420ms;

      /* &.isActive {
         background: white;
         color: ${(props) => props.back || "#32529ds"};
         border-color: ${(props) => props.back || "#32529ds"};
         transition: all 420ms;
      } */
   }
`;
